import { cdnUrl } from "client/config/url";
import { translateFunc } from "client/utils/translateFunc";
import { ComplimentaryIcon } from "components/common/Icons/ColorHarmony/ComplimentaryIcon";
import { TetradicIcon } from "components/common/Icons/ColorHarmony/TetradicIcon";
import { TriadicIcon } from "components/common/Icons/ColorHarmony/TriadicIcon";
import { Translate } from "components/common/Translate/Translate";
import Image from "next/legacy/image";
import { ReactNode } from "react";

interface Harmony {
    title: ReactNode;
    description: ReactNode;
    icon: ReactNode;
}

const getCDNIcon = (src: string, alt: string) => (
    <Image src={`${cdnUrl}/icons${src}`} width={300} height={300} alt={alt} />
);

export const ColorHarmoniesContent = () => {
    const harmonies: Array<Harmony> = [
        {
            title: <Translate keyName="complementary-title" />,
            description: <Translate keyName="complementary-sub-title" />,
            icon: <ComplimentaryIcon />,
        },
        {
            title: <Translate keyName="triadic-title" />,
            description: <Translate keyName="triadic-sub-title" />,
            icon: <TriadicIcon />,
        },
        {
            title: <Translate keyName="tetradic-title" />,
            description: <Translate keyName="tetradic-sub-title" />,
            icon: <TetradicIcon />,
        },
    ];

    return (
        <div className="flex flex-col items-center gap-24 w-full px-4 text-black dark:text-white">
            <div className="flex flex-col gap-4 lg:mx-16 mb-16">
                <h3 className="font-semibold" style={{ fontSize: "22px" }}>
                    <Translate keyName="color-harmony-title" />
                </h3>
                <div>
                    <Translate keyName="color-harmony-sub-title" />
                </div>
            </div>
            {harmonies.map((harmony, index) => {
                return (
                    <div
                        key={index}
                        className={`flex flex-col ${
                            (index + 1) % 2 === 0 ? "lg:flex-row-reverse" : "lg:flex-row"
                        } items-center justify-center gap-16`}
                    >
                        <div className="flex flex-col gap-6 px-2">
                            <h4
                                className="font-semibold"
                                style={{
                                    fontSize: "22px",
                                }}
                            >
                                {harmony.title}
                            </h4>
                            <div
                                style={{
                                    maxWidth: "40ch",
                                }}
                            >
                                {harmony.description}
                            </div>
                        </div>
                        {harmony.icon}
                    </div>
                );
            })}
        </div>
    );
};
